export const CALENDAR_URL = "https://go.prolificmaven.com/widget/bookings/prolificmavendiscovery";
export const CONTACT_EMAIL = "info@prolificmaven.com";
export const CONTACT_PHONE = "(813) 720-3565";
export const CONTACT_PHONE_RAW = "8137203565";

export const HERO_VIDEO_URL = "https://customer-assets.emergentagent.com/job_prolific-maven/artifacts/5bpdygmt_Clarify%2C%20Refine%2C%20Amplify.mp4";

export const NAV_LINKS = [
  { label: "About", to: "/about" },
  { label: "Process", to: "/process" },
  { label: "Services", to: "/services" },
  { label: "Results", to: "/results" },
  { label: "Blog", to: "/blog" },
  { label: "Apply", to: "/apply" },
];

export const SERVICE_AREAS = [
  "Parrish", "Bradenton", "Sarasota", "Tampa", "St. Petersburg", "Lakeland",
  "Palmetto", "Ellenton", "Ruskin", "Sun City Center", "Venice", "North Port",
];

export const IMAGES = {
  writing: "https://static.prod-images.emergentagent.com/jobs/f174b113-823c-4c76-9789-2cc74c7ab9de/images/72719c961a7f4f988d12c5a76e5f1691fb4ceb9a7c7f2278f9d92453f9596851.png",
  quill: "https://static.prod-images.emergentagent.com/jobs/f174b113-823c-4c76-9789-2cc74c7ab9de/images/592dc3dceda443a5f67868a190f355adb3a9094ba14015f300a26f5ba5f63d78.png",
  skyline: "https://static.prod-images.emergentagent.com/jobs/f174b113-823c-4c76-9789-2cc74c7ab9de/images/389732655d4b885bf3029639c9b9450bca2220d4d4695638c4ec7e24f18701c2.png",
  planesMap: "https://static.prod-images.emergentagent.com/jobs/f174b113-823c-4c76-9789-2cc74c7ab9de/images/34d55485fbd7927a8361c357dd3560e8fff0fb38bb75ec5e4d76a1d6c9d3a8b4.png",
  plane: "https://static.prod-images.emergentagent.com/jobs/f174b113-823c-4c76-9789-2cc74c7ab9de/images/5e0d7c25ad64809fe7bffbb76e2eaab3f43ca7a523d3ff000f76fbead4140313.png",
  video: "https://static.prod-images.emergentagent.com/jobs/f174b113-823c-4c76-9789-2cc74c7ab9de/images/36e69cd18cfb7ea4224ec84ec6666e87e3a828a5d76b93624cd27dc2be9cd5e8.png",
  og: "https://static.prod-images.emergentagent.com/jobs/f174b113-823c-4c76-9789-2cc74c7ab9de/images/389732655d4b885bf3029639c9b9450bca2220d4d4695638c4ec7e24f18701c2.png",
};
